<template>
  <div class="steps spaTemplate">
    <div
      class="step-item"
      @click="backStep(0)"
      :class="{
        'is-completed': coutStep > 0 ? true : false,
        'is-hidden-mobile': coutStep !== 0 ? true : false,
        'is-active': coutStep === 0,
      }"
    >
      <div class="step-marker">1<span class="is-hidden-tablet">/2</span></div>
      <div class="step-details">
        <p class="step-title">{{ $t("userDetail.userInformationHeader") }}</p>
      </div>
    </div>
    <div
      class="step-item is-finish"
      @click="backStep(1)"
      :class="{
        'is-hidden-mobile': coutStep !== 1 ? true : false,
        'is-active': coutStep === 1,
      }"
    >
      <div class="step-marker">2<span class="is-hidden-tablet">/2</span></div>
      <div class="step-details">
        <p class="step-title">{{ $t("userDetail.confirmation") }}</p>
      </div>
    </div>
    <div class="steps-content">
      <div class="step-content has-text-centered is-active">
        <div class="boxFormSigUpTitle">
          <div class="">
            <p
              class="is-size-4-desktop is-size-5 has-text-weight-semibold label-Left"
            >
              {{ $t("userDetail.userInformationHeader") }}
            </p>
          </div>
        </div>
        <section>
          <div class="columns m-h-auto">
            <div class="column">
              <div class="columns m-h-auto">
                <div class="column is-4">
                  <p class="is-size-6 has-text-left has-text-weight-semibold">
                    {{ $t("userDetail.coordinatorNameTitle") }}
                  </p>
                  <b-field class="is-padding-sm-y">
                    <b-select
                      @change="$v.titleName.$touch()"
                      v-model="titleName"
                      expanded
                      icon="pen"
                      icon-pack="fas"
                      :placeholder="$t('userDetail.placeholderPrefix')"
                      :class="{
                        'form-error-button': $v.titleName.$error,
                        'placeholder-select-th': titleName === null,
                      }"
                    >
                      <option
                        class="th is-size-6 has-text-black"
                        v-for="item in dataPrefix"
                        :key="item.id"
                        :value="item.name"
                      >
                        {{ $i18n.locale === "th" ? item.name : item.nameEN }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div class="column">
                  <b-field
                    :label="$t('userDetail.labelName')"
                    class="label-Left"
                    :type="$v.name.$error == true ? 'is-danger' : ''"
                  >
                    <b-input
                      :placeholder="$t('userDetail.placeholderName')"
                      type="text"
                      icon-pack="fas"
                      @input="[$v.name.$touch(), checkNext()]"
                      icon="pen"
                      v-model="name"
                    ></b-input>
                  </b-field>
                </div>
              </div>
            </div>
            <div class="column">
              <b-field
                :label="$t('userDetail.labeLastName')"
                :type="$v.surname.$error == true ? 'is-danger' : ''"
                class="label-Left"
              >
                <b-input
                  :placeholder="$t('userDetail.placeholderLastName')"
                  type="text"
                  icon-pack="fas"
                  @input="[$v.surname.$touch(), checkNext()]"
                  icon="pen"
                  v-model="surname"
                ></b-input>
              </b-field>
            </div>
          </div>

          <div class="columns m-h-auto">
            <div class="column is-6">
              <b-field
                :label="$t('signin.departmentLabel')"
                :type="$v.sciencePark.$error == true ? 'is-danger' : ''"
                class="label-Left"
              >
                <b-select
                  expanded
                  icon-pack="fas"
                  icon="pen"
                  :title="sciencePark"
                  v-model="sciencePark"
                  :placeholder="$t('signin.departmentPlaceholder')"
                  :open-on-focus="true"
                  :class="{ 'font-placeholder': sciencePark === null }"
                  :type="$v.sciencePark.$error == true ? 'is-danger' : ''"
                  field="name"
                >
                  <option
                    v-for="(data, index) in filterOrganizeName"
                    :key="index"
                    :value="data.name"
                    class="th is-size-6"
                  >
                    {{ data.name | snippet }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column">
              <b-field
                :label="$t('userDetail.labePosition')"
                class="label-Left"
                :type="$v.position.$error == true ? 'is-danger' : ''"
              >
                <b-input
                  :placeholder="$t('userDetail.placeholderPosition')"
                  type="text"
                  icon-pack="fas"
                  @input="[$v.position.$touch(), checkNext()]"
                  icon="user"
                  v-model="position"
                ></b-input>
              </b-field>
            </div>
          </div>

          <div class="columns m-h-auto">
            <div class="column">
              <b-field
                :label="$t('userDetail.coordinatorTelephone')"
                :type="$v.telephoneNumber.$error == true ? 'is-danger' : ''"
                :class="{ 'form-error': $v.telephoneNumber.$error }"
                class="has-text-left"
              >
                <b-input
                  :placeholder="$t('userDetail.placeholderPhoneNumber')"
                  type="text"
                  maxlength="10"
                  icon-pack="fas"
                  @input="[$v.telephoneNumber.$touch(), checkNext()]"
                  icon="phone"
                  v-model="telephoneNumber"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-6 has-text-right is-primary">
              <b-field
                :label="$t('userDetail.profileImage')"
                class="label-Left"
              >
                <b-upload
                  v-model="profilePic"
                  drag-drop
                  class="is-flex is-align-center"
                >
                  <section class="section">
                    <div
                      class="content has-text-centered is-justify-start is-align-start is-flex-row boxUpload"
                    >
                      <b-icon
                        pack="fas"
                        icon="sync-alt"
                        custom-class="fa-cloud-upload-alt"
                        class="icon-upload"
                      ></b-icon>
                      <p
                        v-if="profileName !== ''"
                        class="is-size-8 text-upload is-margin-right-m"
                        ref="fileLabel"
                      >
                        <span class="is-hidden-mobile">{{
                          profileName | snippet
                        }}</span>
                        <span class="is-hidden-tablet">{{
                          profileName | snippetMobile
                        }}</span>
                      </p>
                      <p v-else class="is-size-8 text-upload" ref="fileLabel">
                        <span class="icon-upload placeholder-th">{{
                          $t("userDetail.placeholderUploadPicture")
                        }}</span>
                      </p>
                    </div>
                  </section>
                </b-upload>
              </b-field>
              <div v-if="profileupload !== ''">
                <span
                  v-if="profileupload == 0"
                  class="is-size-7 th has-text-danger"
                  >{{ $t("form.statusUploadFileFailed") }}</span
                >
                <span
                  v-if="profileupload == 1"
                  class="is-size-7 th has-text-success"
                  >{{ $t("form.statusUploadFileSuccessfully") }}</span
                >
                <span v-if="profileupload == 2" class="is-size-7 th"
                  >{{ $t("form.statusUploadFileUploading") }}....</span
                >
              </div>
            </div>
          </div>

          <div class="columns m-h-auto">
            <div class="column is-6">
              <b-field
                :label="$t('userDetail.coordinatorEmail')"
                :type="$v.email.$error == true ? 'is-danger' : ''"
                class="has-text-left"
                :class="{ 'form-error': $v.email.$error }"
              >
                <b-input
                  :placeholder="$t('userDetail.placeholderEmail')"
                  type="text"
                  icon-pack="fas"
                  @input="[$v.email.$touch(), checkNext()]"
                  icon="envelope"
                  v-model="email"
                ></b-input>
              </b-field>
            </div>
          </div>

          <div class="columns m-h-auto">
            <div class="column">
              <b-field
                :label="$t('userDetail.labelPassword')"
                :type="$v.password.$error == true ? 'is-danger' : ''"
                :message="
                  $v.password.$error == true
                    ? $t('userDetail.validatePassword')
                    : ''
                "
                class="label-Left reveal"
              >
                <b-input
                  :placeholder="$t('userDetail.validatePassword')"
                  @input="[$v.password.$touch(), checkNext()]"
                  type="password"
                  password-reveal
                  icon-pack="mdi"
                  icon="lock"
                  v-model="password"
                ></b-input>
              </b-field>
            </div>
            <div class="column">
              <b-field
                :label="$t('userDetail.labelConfirmPassword')"
                class="label-Left reveal"
                :type="$v.repassword.$error == true ? 'is-danger' : ''"
                :message="
                  $v.repassword.$error == true
                    ? $t('userDetail.validateConfirmPassword')
                    : ''
                "
              >
                <b-input
                  :label="$t('userDetail.validateConfirmPassword')"
                  type="password"
                  password-reveal
                  icon-pack="mdi"
                  icon="lock"
                  v-model="repassword"
                  @input="[$v.repassword.$touch(), checkNext()]"
                ></b-input>
              </b-field>
            </div>
          </div>
        </section>
      </div>
      <div class="step-content has-text-centered is-finish">
        <div class="boxFormSigUpTitleConfirmation">
          <p class="is-size-4 has-text-weight-semibold label-Left">
            {{ $t("userDetail.confirmation") }}
          </p>
        </div>
        <div>
          <div class="is-flex is-justify-spacebetween">
            <div>
              <p
                class="is-size-6 has-text-weight-semibold label-Left paddingTop"
              >
                {{ $t("userDetail.personalHeader") }}
              </p>
            </div>
            <div class="has-text-right-mobile">
              <p
                @click="backStep(0)"
                class="is-size-6 cr-pointer paddingTop cr-pointer has-text-weight-semibold confirm-icon-color editeColorSpa"
              >
                <i
                  class="fas fa-lg fa-pen is-margin-right-sm"
                  v-if="widthMax > 768"
                ></i
                >{{ $t("message.edit") }}
              </p>
            </div>
          </div>
          <hr class="line-title" />
          <div class="columns m-h-auto is-vcentered">
            <div class="column is-1 is-justify-center is-align-center is-flex">
              <figure v-if="coutStep === 1" class="image imgName">
                <img
                  class="is-rounded"
                  v-if="profilePic != ''"
                  :src="imgUrl + profileName"
                />
                <img
                  class="is-rounded"
                  v-else
                  src="https://bulma.io/images/placeholders/64x64.png"
                  alt="Placeholder image"
                />
              </figure>
            </div>
            <div class="column is-centered">
              <div class="columns m-h-auto">
                <div class="column has-text-left level-mobile">
                  <p
                    class="is-size-6 has-text-weight-semibold"
                    :class="{
                      '': widthMax < 768,
                      'is-flex is-align-center': widthMax > 768,
                    }"
                  >
                    <b-icon
                      pack="fas"
                      icon="sync-alt"
                      custom-class="fa-pen"
                      class="confirm-icon-color mg-r-5"
                      v-if="widthMax > 768"
                    ></b-icon>
                    {{ $t("userDetail.labelName") }}:<span
                      class="th confirm-text-color confirm-padding-left fw-100"
                      >{{ titleName }} {{ name }}</span
                    >
                  </p>
                </div>
                <div class="column has-text-left level-mobile">
                  <p
                    class="is-size-6 has-text-weight-semibold"
                    :class="{
                      '': widthMax < 768,
                      'is-flex is-align-center': widthMax > 768,
                    }"
                  >
                    <b-icon
                      pack="fas"
                      icon="sync-alt"
                      custom-class="fa-pen"
                      class="confirm-icon-color mg-r-5"
                      v-if="widthMax > 768"
                    ></b-icon>
                    {{ $t("userDetail.labeLastName") }}:<span
                      class="th confirm-text-color confirm-padding-left fw-100"
                      >{{ surname }}</span
                    >
                  </p>
                </div>
              </div>

              <div class="columns m-h-auto">
                <div class="column has-text-left level-mobile">
                  <p
                    class="is-size-6 has-text-weight-semibold"
                    :class="{
                      '': widthMax < 768,
                      'is-flex is-align-center': widthMax > 768,
                    }"
                  >
                    <b-icon
                      pack="fas"
                      icon="sync-alt"
                      custom-class="fa-pen"
                      class="confirm-icon-color mg-r-5"
                      v-if="widthMax > 768"
                    ></b-icon>
                    {{ $t("userDetail.labelSelectDepartment") }}:<span
                      class="th confirm-text-color confirm-padding-left fw-100"
                      >{{ sciencePark }}</span
                    >
                  </p>
                </div>
                <div class="column has-text-left level-mobile">
                  <p
                    class="is-size-6 has-text-weight-semibold"
                    :class="{
                      '': widthMax < 768,
                      'is-flex is-align-center': widthMax > 768,
                    }"
                  >
                    <b-icon
                      pack="fas"
                      icon="sync-alt"
                      custom-class="fa-pen"
                      class="confirm-icon-color mg-r-5"
                      v-if="widthMax > 768"
                    ></b-icon>
                    {{ $t("userDetail.labePosition") }}:<span
                      class="th confirm-text-color confirm-padding-left fw-100"
                      >{{ position }}</span
                    >
                  </p>
                </div>
              </div>

              <div class="columns m-h-auto">
                <div class="column is-6 has-text-left level-mobile">
                  <p
                    class="is-size-6 has-text-weight-semibold"
                    :class="{
                      '': widthMax < 768,
                      'is-flex is-align-center': widthMax > 768,
                    }"
                  >
                    <b-icon
                      pack="fas"
                      icon="sync-alt"
                      custom-class="fa-pen"
                      class="confirm-icon-color mg-r-5"
                      v-if="widthMax > 768"
                    ></b-icon>
                    {{ $t("userDetail.coordinatorTelephone") }}:<span
                      class="th confirm-text-color confirm-padding-left fw-100"
                      >{{ telephoneNumber }}</span
                    >
                  </p>
                </div>
                <div class="column is-6 has-text-left level-mobile">
                  <p
                    class="is-size-6 has-text-weight-semibold"
                    :class="{
                      '': widthMax < 768,
                      'is-flex is-align-center': widthMax > 768,
                    }"
                  >
                    <b-icon
                      pack="fas"
                      icon="sync-alt"
                      custom-class="fa-pen"
                      class="confirm-icon-color mg-r-5"
                      v-if="widthMax > 768"
                    ></b-icon>
                    {{ $t("userDetail.addActivityHeaderEmail") }}:<span
                      class="th confirm-text-color confirm-padding-left fw-100"
                      >{{ email }}</span
                    >
                  </p>
                </div>
              </div>

              <div class="columns m-h-auto">
                <div class="column has-text-left level-mobile">
                  <p
                    class="is-size-6 has-text-weight-semibold"
                    :class="{
                      '': widthMax < 768,
                      'is-flex is-align-center': widthMax > 768,
                    }"
                  >
                    <b-icon
                      pack="fas"
                      icon="sync-alt"
                      custom-class="fa-lock"
                      class="confirm-icon-color mg-r-5"
                      v-if="widthMax > 768"
                    ></b-icon>
                    {{ $t("userDetail.labelPassword") }}:
                    <i
                      class="fas fa-circle is-margin-left-sm"
                      v-for="(item, index) in checkPassHide(password)"
                      :key="index"
                    ></i>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="is-justify-center is-align-center is-flex">
            <div class="steps-action boxBtnNext confirm-margin-bottom">
              <button
                @click="loadingSignup ? null : onSubmit()"
                class="button is-light is-btn-link spaTemplate has-text-centered"
              >
                {{ $t("message.btnNext") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="is-justify-center is-align-center is-flex-medium is-flex-column pd-10 mg-t-40"
    >
      <p
        v-if="coutStep === 0"
        class="th is-size-6 has-text-centered"
        :class="widthMax > 768 ? 'is-flex' : ''"
      ></p>
      <p v-if="coutStep === 0" class="th is-size-6">
        <b-checkbox
          size="is-small"
          type="is-black"
          v-model="confirmTC"
        ></b-checkbox
        >{{ $t("signin.accept1") }}
        <a href="/terms-of-use/admin" target="_blank">
          {{ $t("signin.termsService") }}</a
        >
        {{ $t("signin.and") }}
        <a href="/privacy-policy/admin" target="_blank">{{
          $t("signin.privacyPolicy")
        }}</a>
      </p>
      <p v-if="agree" style="color: #ff3860">
        {{ $t("signin.accept2") }}
      </p>
    </div>
    <div class="steps-actions">
      <div
        class="steps-action is-marginless"
        :class="{ 'pd-y-22': coutStep === 0 }"
      >
        <button
          @click="nextStep()"
          class="button is-light spaTemplate is-btn-link"
        >
          {{ $t("message.btnNext") }}
        </button>
      </div>
    </div>
    <b-loading :active.sync="loadingSignup"></b-loading>
    <div
      class="is-justify-center is-align-center is-flex-medium is-flex-column pd-10"
    >
      <p v-if="coutStep === 0" class="th is-size-6 has-text-centered">
        {{ $t("signin.footer3") }}
        <a @click="$router.push('/signin')" class="color-orange">{{
          $t("signin.signinButton")
        }}</a>
        {{ $t("signin.footer2") }}
      </p>
      <p v-if="coutStep === 0" class="th mg-t-30 has-text-centered">
        <span class="th font-14 text-grey"> {{ $t("signin.version") }}</span>
      </p>
    </div>
  </div>
</template>
<script>
import { checkPassHide } from "../service/password";
import { HTTP } from "../axios.js";
import axios from "axios";
import {
  required,
  minLength,
  sameAs,
  between,
  numeric,
  email,
  helpers,
} from "vuelidate/lib/validators";
const text = helpers.regex("text", /^[a-zA-Zก-๙ ]*$/);
export default {
  validations: {
    email: {
      required,
      email,
    },
    name: {
      required,
      text,
    },
    password: {
      required,
      minLength: minLength(8),
    },
    repassword: {
      sameAsPassword: sameAs("password"),
    },
    surname: {
      required,
      text,
    },
    position: {
      required,
    },
    telephoneNumber: {
      numeric,
      required,
      minLength: minLength(10),
    },
    titleName: {
      required,
    },
    sciencePark: {
      required,
    },
    confirmTC: {
      required,
    },
  },
  props: ["stepIndex"],
  data() {
    return {
      sciencePark: null,
      batchName: null,
      fiscalYear: null,
      validateNext: false,
      batchId: "",
      userLevel: 50,
      name: "",
      surname: "",
      profilePic: [],
      email: "",
      position: "",
      password: "",
      repassword: "",
      telephoneNumber: "",
      organizeLogo: [],
      file: "",
      token: "",
      currentStep: "",
      batchId: this.$route.params.id,
      tokenAuth: "",
      profileupload: "",
      logoupload: false,
      profileName: "",
      coutStep: 0,
      titleName: null,
      loadingSignup: false,
      widthMax: window.innerWidth,
      imgUrl: process.env.VUE_APP_IMAGE_URL,
      confirmTC: false,
      dataOrganization: [],
      isConnected: false,
      underID: null,
      agree: null,
    };
  },
  watch: {
    profilePic() {
      if (this.profilePic) {
        this.checkProfile();
      }
    },
  },
  computed: {
    filterOrganizeName() {
      return this.dataOrganization.filter((option) => {
        if (option.underId === this.underID) {
          if (typeof option.name != "undefined") {
            return option.name.toString().toLowerCase();
          }
        }
      });
    },
    dataPrefix() {
      return this.$store.state.prefix;
    },
    tokenJoin() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
  },
  created() {
    this.imgUrl = process.env.VUE_APP_IMAGE_URL;
    this.$store.commit("setSpaPage", "spa");
  },
  async mounted() {
    this.getUnderIdinBatch();
    this.getOrganization();
    await this.getToken();
    if (typeof this.user !== "undefined" && this.user !== null) {
      await this.checkBatch();
    }
  },
  methods: {
    getUnderIdinBatch() {
      HTTP.post("/api/get/under/in/batch", {
        batchId: this.$route.params.id,
      }).then((res) => {
        this.underID = res.data.obj;
      });
    },
    getOrganization() {
      HTTP.post("/get/all/science/park").then((res) => {
        this.dataOrganization = res.data.obj;
      });
    },
    async getToken() {
      await HTTP.get(`api/user/get/token/admin/register/batch/${this.batchId}`)
        .then((result) => {
          // console.log("api/user/get/token/admin/register/batch/",result)
          // this.token = result.data.token
          this.fiscalYear = result.data.obj.fiscalYear;
          this.batchName = result.data.obj.batchName;
          this.tokenAuth = result.data.obj.token;
          // console.log("this.batchName",this.batchName)
        })
        .catch((e) => {
          // console.log("api/user/get/token/admin/register/batch/error",result)
          alert("เครือขายไม่เสถียร กรุณาลองใหม่");
        });
    },
    checkBatch() {
      if (this.user.userLevel == 50) {
        if (this.tokenJoin) {
          this.$buefy.dialog.confirm({
            message: `<h3 class="title is-4">คุณต้องการเข้าร่วม Batch นี้หรือไม่?</h3><p><span class="has-text-weight-normal">โครงการ</span> ${this.batchName}</p><p><span class="has-text-weight-normal">ปีงบประมาน</span> ${this.fiscalYear}</p>`,
            confirmText: "ยกเลิก",
            cancelText: "เข้าร่วม",
            // onConfirm: () => this.$toast.open('User confirmed'),
            onCancel: () => this.checkJoinBatch(),
            onConfirm: () => this.$router.push("/batch/view"),
          });
        }
      } else {
        this.$buefy.dialog.alert(
          '<p class="has-text-centered is-size-4">คุณไม่สามารถเข้าร่วม Batch นี้ได้</p>'
        );
        this.$router.push("/batch/view");
      }
    },
    checkJoinBatch() {
      const data = {
        batchId: this.$route.params.id,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.tokenJoin}`;
      HTTP.post("api/invite/to/batch/from/link", data)
        .then((res) => {
          // console.log("api/invite/to/batch/from/link",res)
          if (res.data.message === "Invalid authorization header") {
          } else if (res.data.msg === "this user joined.") {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-4">คุณอยู่ใน Batch นี้แล้ว</p>'
            );
            this.$router.push("/batch/view");
          } else {
            this.emitRealTimeAddStaff();
            this.$router.push("/batch/view");
          }
        })
        .catch((e) => {
          console.log("api/invite/to/batch/from/link/error", e);
        });
    },
    backStep(index) {
      this.stepIndex.activate_step(index);
      switch (index) {
        case 0:
          this.coutStep = 0;
          break;
        case 1:
          this.coutStep = 1;
          break;
        default:
          break;
      }
    },
    nextStep() {
      switch (this.coutStep) {
        case 0:
          this.$v.$touch();
          if (this.$v.$invalid) {
          } else if (this.profileupload == 1) {
            if (this.confirmTC) {
              const data = {
                email: this.email,
              };

              HTTP.post("api/user/check/email", data)
                .then((res) => {
                  // console.log("api/user/check/email", res);
                  if (res.data.success) {
                    this.agree = false;
                    this.stepIndex.activate_step(1);
                    this.coutStep = 1;
                  } else {
                    alert(
                      "อีเมลนี้ถูกใช้งานแล้ว หรือ ต้องการเข้าร่วม Batch นี้ ให้กด Sign in เพื่อเข้าสู่ระบบ"
                    );
                  }
                })
                .catch((e) => {
                  this.agree = true;
                  console.log("api/user/check/email/error", e);
                });
            } else {
              this.agree = true;
              alert(
                "กรุณายอมรับเงื่อนไขการใช้บริการ และ นโยบายความเป็นส่วนตัว"
              );
            }
          } else {
            alert("กรุณาอัพโหลดรูปโปรไฟล์");
          }
          break;
        default:
          break;
      }
    },
    checkNext() {
      if (
        this.titleName != "" &&
        this.name != "" &&
        this.surname != "" &&
        this.profilePic.length != 0 &&
        this.email != "" &&
        this.position != "" &&
        this.password != "" &&
        this.repassword != "" &&
        this.telephoneNumber != ""
      ) {
        this.$v.$touch();
        if (this.$v.$invalid) {
        } else {
          this.validateNext = true;
        }
      }
    },
    async checkProfile() {
      const type = this.profilePic.type;
      this.profileupload = 2;
      if (
        type === "image/jpeg" ||
        type === "image/png" ||
        type === "image/gif"
      ) {
        const profile = new FormData();
        profile.append("profileImage", this.profilePic);
        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        await HTTP.post("upload/profile", profile, config).then((result) => {
          if (result.data !== "") {
            this.profileupload = 1;
            this.profileName = result.data;
          } else {
            this.profileupload = 0;
          }
        });
      } else {
        this.profilePic = [];
        this.profileupload = 0;
        alert("รูปโปรไฟล์ ระบบไม่รองรับรูปแบบไฟล์");
      }
    },
    async onSubmit() {
      if (this.profileupload == 1) {
        this.$v.$touch();
        if (this.$v.$invalid) {
        } else {
          this.loadingSignup = true;
          const profile = new FormData();
          profile.append("profileImage", this.profilePic);
          this.$store.dispatch("UPLOAD_PROFILE_IMAGE", profile);
          //console.log('profile',profile)
          const data = {
            batchId: this.batchId,
            userLevel: this.userLevel,
            name: this.name,
            surname: this.surname,
            profilePic: this.profileName,
            email: this.email,
            password: this.password,
            repassword: this.repassword,
            position: this.position,
            tokenAuth: this.tokenAuth,
            mobilePhone: this.telephoneNumber,
            titleName: this.titleName,
            isSpa: true,
            scienceParkName: this.sciencePark,
          };

          let tmpUser;
          //console.log(data)
          HTTP.defaults.headers.common.Authorization = `Bearer ${data.tokenAuth}`;
          HTTP.post("api/user/check/email", data).then((result) => {
            if (result.data.success) {
              HTTP.post("api/user", data)
                .then((res) => {
                  //console.log('respon add user', res);
                  if (res.data.success) {
                    this.emitRealTimeAddStaff();
                    this.emitRealTimeNotiAddStaff();
                    this.$router.push("/spa/sign-up/finish/staff");
                  } else {
                    alert("สมัครสมาชิกล้มเหลว กรุณาสมัครใหม่");
                    this.loadingSignup = false;
                  }
                })
                .catch((e) => {
                  console.log("respon add user error", e.response);
                  this.loadingSignup = false;
                });
            } else {
              this.loadingSignup = false;
              alert(
                "อีเมลนี้ถูกใช้งานแล้ว หรือ ต้องการเข้าร่วม Batch นี้ ให้กด Sign in เพื่อเข้าสู่ระบบ"
              );
            }
            this.loadingSignup = false;
          });
        }
      } else {
        alert("กรุณาอัพโหลดรูปโปรไฟล์ และ โลโก้บริษัท");
      }
    },
    emitRealTimeAddStaff() {
      this.$socket.emit("listStaffInBatch", {
        batchId: this.batchId,
      });
    },
    emitRealTimeNotiAddStaff() {
      this.$socket.emit("listNoti", {
        userId: "",
        batchId: this.batchId,
      });
    },
  },
};
</script>

<style scoped>
.step-content .is-finish.is-active ~ .steps-actions {
  display: none;
}
.boxFormSigUp {
  margin-top: 2rem;
}
.boxFormSigUpTitle {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.boxFormSigUpTitleConfirmation {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.sigleForm {
  padding-right: 41rem;
}
.boxBtnNext {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.is-btn-link {
  height: 3rem !important;
}
.hrPadding {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.paddingTop {
  padding-top: 2.5rem;
}
.section {
  padding-bottom: 0.1rem !important;
  padding-top: 0.1rem !important;
  padding-left: 0.7rem !important;
  padding-right: 0 !important;
}
.boxUpload {
  display: flex !important;
  height: 1.6rem;
  width: 37.5rem;
}
.textAndiconBackInformation {
  font-size: 0.8rem;
  color: #d8d8d8;
}
.paddingTop {
  padding-top: 1rem;
}
.boxPointPass {
  display: flex !important;
  width: 5rem;
}
.marginLine {
  margin-top: 1.5rem !important;
}
/*div.step-item {
  visibility: hidden;
}*/
.iconSucces {
  margin-top: 3rem;
}
.step-item.is-finish.is-active ~ .steps-actions {
  display: none;
}
.btnSigIn {
  width: 17rem;
  margin-top: 2rem;
  background-color: #6d8df3 !important;
  color: #fff !important;
}
.subTitleStart {
  font-size: 20px;
  color: #000000;
  margin-top: 1rem;
}
.button.is-light[disabled] {
  visibility: hidden;
}

.control.has-icons-left .select select {
  height: 100%;
}
.select:not(.is-multiple) {
  width: 100%;
}
.box .steps .step-item.is-active .step-marker,
.box .steps .step-item.is-success.is-active .step-marker {
  color: #f15a29;
  border-color: #f15a29;
}
</style>
